export default __webpack_public_path__ + "static/media/logo.7d00b79b.png";